import BaseService from '@/services/BaseService';

class PagesService extends BaseService {
    updateHomePage = (data) => this.post('/edit-home-page', data);

    viewHomePage = () => this.get('/view-home-page');

    updateAboutPage = (data) => this.post('/edit-about-page', data);

    viewAboutPage = () => this.get('/view-about-page');

    updateLiteraturePage = (data) => this.post('/edit-literature-page', data);

    viewLiteraturePage = () => this.get('/view-literature-page');

    updateTechnicalDataPage = (data) => this.post('/edit-technical-data-page', data);

    viewTechnicalDataPage = () => this.get('/view-technical-data-page');

    updateCertificationPage = (data) => this.post('/edit-certification-page', data);

    viewCertificationPage = () => this.get('/view-certification-page');

    updateMainPage = (data) => this.post('/edit-main-page', data);

    viewMainPage = () => this.get('/view-main-page');

    updateFaqsPage = (data) => this.post('/edit-faqs-page', data);

    viewFaqsPage = () => this.get('/view-faqs-page');

    getPageList = (data) => this.post('/get-page-list', data || {});

    updateCrossReferencePage = (data) => this.post('/edit-cross-reference-page', data);

    viewCrossReferencePage = () => this.get('/view-cross-reference-page');

    updateSolutionsPage = (data) => this.post('/edit-solutions-page', data);

    viewSolutionsPage = () => this.get('/view-solutions-page');

    updatePrivacyPage = (data) => this.post('/edit-privacy-page', data);

    viewPrivacyPage = () => this.get('/view-privacy-page');

    updateTermsAndConditionsPage = (data) => this.post('/edit-terms-and-conditions-page', data);

    viewTermsAndConditionsPage = () => this.get('/view-terms-and-conditions-page');

    updateContactPage = (data) => this.post('/edit-contact-page', data);

    viewContactPage = () => this.get('/view-contact-page');

    updatePlantLocationsPage = (data) => this.post('/edit-plant-locations-page', data);

    viewPlantLocationsPage = () => this.get('/view-plant-locations-page');
}

export default new PagesService();
